import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import RadioField from '@common/components/FormElements/RadioField';
import asReduxFormField from '@common/components/FormElements/asReduxFormField';

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin-bottom: 40px;
`;

const Label = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 20px;
`;

const ListItem = styled.li`
  display: flex;
  align-items: center;
  border: 1px solid
    ${({ theme, isChecked }) =>
      isChecked ? theme.customColors.primary : theme.defaultColors.lightGrey};
  margin-bottom: 10px;
  border-radius: 3px;
  cursor: pointer;

  p {
    display: none;
  }

  &:hover {
    border: 1px solid ${({ theme }) => theme.customColors.primary};
  }
`;

const OptionPickerComponent = ({ options, onChange, value, label, getOptionLabel }) => (
  <>
    <h3>{label}</h3>
    <List>
      {options.map((option, index) => (
        <ListItem isChecked={option.id === value.id} key={index}>
          <Label htmlFor={`option-picker-${index}`}>
            <strong>{getOptionLabel ? getOptionLabel(option) : option.name}</strong>
          </Label>
          <RadioField
            type="radio"
            name="option-picker"
            id={`option-picker-${index}`}
            onChange={() => onChange(option)}
            isChecked={option.id === value.id}
            value={option.value}
            isDisabled={option.isDisabled}
          />
        </ListItem>
      ))}
    </List>
  </>
);

OptionPickerComponent.propTypes = {
  value: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
};

const OptionPicker = asReduxFormField(OptionPickerComponent);

export default OptionPicker;
